export const MIN_VALUE = 1;
export const MAX_VALUE = 100;
